import React from 'react';
import styles from './style.module.css';
import { useHistory, Link } from 'react-router-dom';

const NotFound = () => {
  const history = useHistory();
  return (
    <div className="coop-l-container">
      <div id="error_page" className={`${styles.inner} coop-l-medium-8 coop-l-large-6`}>
        <h1>Error 404</h1>
        <h2>Page not found</h2>
        <p className="coop-u-margin-bh">We couldn’t find the page you’re looking for.</p>
        <p>
          It’s probably best if you <Link to="/pharmacy">return to our sign in page</Link>.
        </p>
      </div>
    </div>
  );
};

export default NotFound;
